import initialState from './state'

const datatables = (state = initialState, action) => {
  switch (action.type) {
    case 'modal_customer_transaction_game':
      return {
        ...state,
        modal_customer_transaction_game: action.data
      }
    case 'modal_customer_transaction_game_winloss':
      return {
        ...state,
        modal_customer_transaction_game_winloss: action.data
      }
    case 'modal_customer_transaction_game_wheel':
      return {
        ...state,
        modal_customer_transaction_game_wheel: action.data
      }
    case 'modal_customer_transaction_game_ticket':
      return {
        ...state,
        modal_customer_transaction_game_ticket: action.data
      }
    case 'modal_customer_activity':
      return {
        ...state,
        modal_customer_activity: action.data
      }
    case 'modal_customer_transaction_credit':
      return {
        ...state,
        modal_customer_transaction_credit: action.data
      }
    case 'modal_customer_invite_friend':
      return {
        ...state,
        modal_customer_invite_friend: action.data
      }
    case 'modal_customer_commission_list':
      return {
        ...state,
        modal_customer_commission_list: action.data
      }
    case 'modal_customer_friend_summary':
      return {
        ...state,
        modal_customer_friend_summary: action.data
      }
    case 'modal_customer_promotion':
      return {
        ...state,
        modal_customer_promotion: action.data
      }
    case 'modal_customer_shop':
      return {
        ...state,
        modal_customer_shop: action.data
      }
    case 'modal_customer_wallets':
      return {
        ...state,
        modal_customer_wallets: action.data
      }
    case 'modal_customer_banks':
      return {
        ...state,
        modal_customer_banks: action.data
      }
    case 'organization_agentbank_payment_711_list':
      return {
        ...state,
        organization_agentbank_payment_711_list: action.data
      }
    case 'organization_sub_history':
      return {
        ...state,
        organization_sub_history: action.data
      }
    case 'organization_follow':
      return {
        ...state,
        organization_follow: action.data
      }
    // cleardata
    case 'clear_modal_customer_list':
      return {
        ...state,
        modal_customer_transaction_game: action.data,
        modal_customer_activity: action.data,
        modal_customer_transaction_credit: action.data,
        modal_customer_invite_friend: action.data,
        modal_customer_promotion: action.data,
        modal_customer_shop: action.data,
        modal_customer_wallets: action.data,
        modal_customer_banks: action.data
      }
    //payment
    case 'bank_bot_list':
      return {
        ...state,
        bank_bot_list: action.data
      }
    case 'deposit_list':
      return {
        ...state,
        deposit_list: action.data
      }
    case 'withdraw_list':
      return {
        ...state,
        withdraw_list: action.data
      }
    case 'topup_list':
      return {
        ...state,
        topup_list: action.data
      }
    case 'organization_agentbank_transaction_list':
      return {
        ...state,
        organization_agentbank_transaction_list: action.data
      }
    case 'organization_agentbank_channel_list':
      return {
        ...state,
        organization_agentbank_channel_list: action.data
      }
    case 'financial_compare_list':
      return {
        ...state,
        financial_compare_list: action.data
      }
    case 'financial_summary_list':
      return {
        ...state,
        financial_summary_list: action.data
      }
    case 'financial_summary_fee':
      return {
        ...state,
        financial_summary_fee: action.data
      }
    case 'financial_bank_result':
      return {
        ...state,
        financial_bank_result: action.data
      }
    case 'financial_payment_gateway_result':
      return {
        ...state,
        financial_payment_gateway_result: action.data
      }
    case 'financial_transfer_list':
      return {
        ...state,
        financial_transfer_list: action.data
      }
    case 'financial_modal_list':
      return {
        ...state,
        financial_modal_list: action.data
      }
    case 'financial_detail_list':
      return {
        ...state,
        financial_detail_list: action.data
      }

    //customer
    case 'customer_list':
      return {
        ...state,
        customer_list: action.data
      }
    case 'category_list':
      return {
        ...state,
        category_list: action.data
      }
    case 'affiliate_list':
      return {
        ...state,
        affiliate_list: action.data
      }
    case 'agent_social_list':
      return {
        ...state,
        agent_social_list: action.data
      }
    case 'chat_bot_list':
      return {
        ...state,
        chat_bot_list: action.data
      }
    case 'chat_bot_ticket_list':
      return {
        ...state,
        chat_bot_ticket_list: action.data
      }
    case 'chat_bot_group_list':
      return {
        ...state,
        chat_bot_group_list: action.data
      }
    case 'chat_bot_history_list':
      return {
        ...state,
        chat_bot_history_list: action.data
      }
    case 'organization_sub_list':
      return {
        ...state,
        organization_sub_list: action.data
      }
    //report
    case 'win_loss_list':
      return {
        ...state,
        win_loss_list: action.data
      }
    case 'win_loss_game_list':
      return {
        ...state,
        win_loss_game_list: action.data
      }
    case 'win_loss_customer_list':
      return {
        ...state,
        win_loss_customer_list: action.data
      }
    case 'commission_list':
      return {
        ...state,
        commission_list: action.data
      }
    case 'commission_category_list':
      return {
        ...state,
        commission_category_list: action.data
      }
    case 'cashback_list':
      return {
        ...state,
        cashback_list: action.data
      }
    case 'cashback_category_list':
      return {
        ...state,
        cashback_category_list: action.data
      }
    case 'game_cmap_list':
      return {
        ...state,
        game_cmap_list: action.data
      }
    case 'deposit_again_list':
      return {
        ...state,
        deposit_again_list: action.data
      }
    case 'customer_disappear':
      return {
        ...state,
        customer_disappear: action.data
      }
    case 'organization_agent_credit_transaction':
      return {
        ...state,
        organization_agent_credit_transaction: action.data
      }
    case 'marketing_report_referral':
      return {
        ...state,
        marketing_report_referral: action.data
      }
    case 'marketing_report_summary_referral':
      return {
        ...state,
        marketing_report_summary_referral: action.data
      }
    case 'report_mission_wheel':
      return {
        ...state,
        report_mission_wheel: action.data
      }
    case 'report_activity_apply':
      return {
        ...state,
        report_activity_apply: action.data
      }


    //setting
    case 'setting_role_list':
      return {
        ...state,
        setting_role_list: action.data
      }
    case 'game_list':
      return {
        ...state,
        game_list: action.data
      }
    case 'image_game_list':
      return {
        ...state,
        image_game_list: action.data
      }
    case 'banner_slide_list':
      return {
        ...state,
        banner_slide_list: action.data
      }
    case 'banner_slide_event_list':
      return {
        ...state,
        banner_slide_event_list: action.data
      }
    case 'banner_slide_hot_list':
      return {
        ...state,
        banner_slide_hot_list: action.data
      }
    case 'customer_referral_summary':
      return {
        ...state,
        customer_referral_summary: action.data
      }
    case 'setting_contact_list':
      return {
        ...state,
        setting_contact_list: action.data
      }
    case 'organization_agentbank_list':
      return {
        ...state,
        organization_agentbank_list: action.data
      }
    case 'setting_agent_list':
      return {
        ...state,
        setting_agent_list: action.data
      }
    case 'setting_agent_cms_list':
      return {
        ...state,
        setting_agent_cms_list: action.data
      }
    case 'mission_wheel_list':
      return {
        ...state,
        mission_wheel_list: action.data
      }
    case 'event_activity_list':
      return {
        ...state,
        event_activity_list: action.data
      }
    case 'event_activity_choose_list':
      return {
        ...state,
        event_activity_choose_list: action.data
      }
    case 'event_activity_reward_list':
      return {
        ...state,
        event_activity_reward_list: action.data
      }

    //promotion
    case 'promotion_apply_list':
      return {
        ...state,
        promotion_apply_list: action.data
      }
    case 'promotion_code_list':
      return {
        ...state,
        promotion_code_list: action.data
      }

    //lottery 
    case 'lottery_ticket':
      return {
        ...state,
        lottery_ticket: action.data
      }
    case 'lottery_ticket_number':
      return {
        ...state,
        lottery_ticket_number: action.data
      }
    case 'lottery_round_result':
      return {
        ...state,
        lottery_round_result: action.data
      }
    case 'setting_category_withdraw_list':
      return {
        ...state,
        setting_category_withdraw_list: action.data
      }

    //marketing
    case 'transfer_customer':
      return {
        ...state,
        transfer_customer: action.data
      }
    case 'customer_referral_summary':
      return {
        ...state,
        customer_referral_summary: action.data
      }
    case 'marketing_referral_customer_list':
      return {
        ...state,
        marketing_referral_customer_list: action.data
      }
    case 'marketing_referral_member_list':
      return {
        ...state,
        marketing_referral_member_list: action.data
      }
    case 'transaction_analyze_list':
      return {
        ...state,
        transaction_analyze_list: action.data
      }
    case 'transaction_credit_list':
      return {
        ...state,
        transaction_credit_list: action.data
      }
    case 'marketing_tracking_list':
      return {
        ...state,
        marketing_tracking_list: action.data
      }
    case 'agent_payment_gate_score_list':
      return {
        ...state,
        agent_payment_gate_score_list: action.data
      }
    case 'setting_pgscore_weight_list':
      return {
        ...state,
        setting_pgscore_weight_list: action.data
      }
    case 'setting_member_whitelist':
      return {
        ...state,
        setting_member_whitelist: action.data
      }
    case 'agent_billing_table':
      return {
        ...state,
        agent_billing_table: action.data
      }
    case 'agent_bank_wallet_account':
      return {
        ...state,
        agent_bank_wallet_account: action.data
      }
    case 'cronjob_list':
      return {
        ...state,
        cronjob_list: action.data
      }

    //hero
    case 'hero_admin_lottery_list':
      return {
        ...state,
        hero_admin_lottery_list: action.data
      }
    case 'hero_admin_lottery_default_list':
      return {
        ...state,
        hero_admin_lottery_default_list: action.data
      }
    case 'hero_admin_lottery_round_list':
      return {
        ...state,
        hero_admin_lottery_round_list: action.data
      }
    case 'hero_admin_lottery_ticket_number':
      return {
        ...state,
        hero_admin_lottery_ticket_number: action.data
      }
    case 'hero_admin_lottery_report_result_lottery_type':
      return {
        ...state,
        hero_admin_lottery_report_result_lottery_type: action.data
      }
    case 'hero_admin_lottery_special_list':
      return {
        ...state,
        hero_admin_lottery_special_list: action.data
      }
    case 'hero_admin_lottery_unlimit_list':
      return {
        ...state,
        hero_admin_lottery_unlimit_list: action.data
      }
    case 'hero_admin_lottery_special_list_round':
      return {
        ...state,
        hero_admin_lottery_special_list_round: action.data
      }

    case 'hero_admin_lottery_report_winloss':
      return {
        ...state,
        hero_admin_lottery_report_winloss: action.data
      }
    case 'hero_admin_lottery_report_bigwin':
      return {
        ...state,
        hero_admin_lottery_report_bigwin: action.data
      }
    case 'hero_admin_lottery_price':
      return {
        ...state,
        hero_admin_lottery_price: action.data
      }
    case 'hero_admin_lottery_report_result_number':
      return {
        ...state,
        hero_admin_lottery_report_result_number: action.data
      }
    case 'hero_admin_lottery_report_unlimit_number':
      return {
        ...state,
        hero_admin_lottery_report_unlimit_number: action.data
      }
    case 'hero_admin_lottery_report_transaction':
      return {
        ...state,
        hero_admin_lottery_report_transaction: action.data
      }
    case 'hero_admin_lottery_report_result_user':
      return {
        ...state,
        hero_admin_lottery_report_result_user: action.data
      }
    case 'hero_admin_lottery_price_customer_list':
      return {
        ...state,
        hero_admin_lottery_price_customer_list: action.data
      }
    case 'customer_online':
      return {
        ...state,
        customer_online: action.data
      }
    case 'game_analysis':
      return {
        ...state,
        game_analysis: action.data
      }
    case 'profitloss_report':
      return {
        ...state,
        profitloss_report: action.data
      }
    case 'hero_admin_lottery_setting_review':
      return {
        ...state,
        hero_admin_lottery_setting_review: action.data
      }
    case 'setting_agent_cms_gametype_list':
      return {
        ...state,
        setting_agent_cms_gametype_list: action.data
      }
    case 'setting_agent_cms_menu_list':
      return {
        ...state,
        setting_agent_cms_menu_list: action.data
      }
    case 'setting_sms_template_list':
      return {
        ...state,
        setting_sms_template_list: action.data
      }
    case 'setting_sms_list':
      return {
        ...state,
        setting_sms_list: action.data
      }
    case 'setting_sms_history_list':
      return {
        ...state,
        setting_sms_history_list: action.data
      }
    case 'analyze_promotion_apply':
      return {
        ...state,
        analyze_promotion_apply: action.data
      }
    case 'hero_admin_lottery_round_risk_list':
      return {
        ...state,
        hero_admin_lottery_round_risk_list: action.data
      }
    case 'domain_registration_list':
      return {
        ...state,
        domain_registration_list: action.data
      }
    case 'agent_infrastructure_list':
      return {
        ...state,
        agent_infrastructure_list: action.data
      }
    case 'hero_admin_lottery_bugget_rate_list':
      return {
        ...state,
        hero_admin_lottery_bugget_rate_list: action.data
      }
    case 'lottery_short_list':
      return {
        ...state,
        lottery_short_list: action.data
      }
    case 'lottery_type_short_list':
      return {
        ...state,
        lottery_type_short_list: action.data
      }
    case 'lottery_cronjob_list':
      return {
        ...state,
        lottery_cronjob_list: action.data
      }
    default:
      return { ...state }
  }

}

export default datatables
